<template>
  <v-container fluid class="paywall-container">
    <v-row justify="center" align="center" class="fill-height">
      <v-col cols="12" sm="10" md="8" lg="6" xl="5">
        <v-card class="paywall-card" elevation="12">
          <v-card-title class="text-center paywall-title">
            <v-icon large color="warning" class="mb-2">mdi-lock</v-icon>
            <div class="headline font-weight-bold">{{ $t('core.subscriptionExpired') }}</div>
          </v-card-title>
          
          <v-card-text class="text-center">
            <p class="subtitle-1 mb-4">
              {{ $t('core.yourSubscriptionHasExpiredPleaseRenew') }}
            </p>
            
            <v-divider class="my-4"></v-divider>
            
            <div v-if="subscriptionData && subscriptionData.subscription" class="mb-4">
              <v-chip color="error" outlined class="mb-2">
                <v-icon left small>mdi-calendar-alert</v-icon>
                {{ $t('common.expired') }}
              </v-chip>
              
              <div v-if="subscriptionData.subscription.plan" class="mt-3">
                <p class="body-1">
                  <strong>{{ $t('core.previousPlan') }}</strong> {{ subscriptionData.subscription.plan.name }}
                </p>
                <p v-if="displayExpirationDate" class="body-2 text--secondary">
                  {{ $t('core.expiredOnX', [formatDate(displayExpirationDate)]) }}
                </p>
              </div>
            </div>
            
            <div v-else class="mb-4">
              <p class="body-1 text--secondary">
                {{ $t('core.noActiveSubscriptionFound') }}
              </p>
            </div>
            
            <v-divider class="my-4"></v-divider>
            
            <v-btn
              color="primary"
              large
              block
              depressed
              class="pay-now-btn"
              @click="handlePayNow"
            >
              <v-icon left>mdi-credit-card</v-icon>
              {{ $t('common.payNow') }}
            </v-btn>
            
            <p class="caption text--secondary mt-3">
              {{ $t('core.clickPayNowToBeRedirected') }}
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Paywall',
  props: {
    subscriptionData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    displayExpirationDate() {
      if (!this.subscriptionData || !this.subscriptionData.subscription) {
        return null;
      }
      
      const subscription = this.subscriptionData.subscription;
      const endDate = subscription.end_date;
      const startDate = subscription.start_date;
      const status = subscription.status;
      
      // If subscription is in pending_payment or expired status, and start_date is the first day of a month,
      // then calculate the last day of the previous month as the actual expiration date
      if ((status === 'pending_payment' || status === 'expired') && startDate && endDate) {
        try {
          // Parse start_date (format: YYYY-MM-DD)
          const [startYear, startMonth, startDay] = startDate.split('-').map(Number);
          
          // Check if start_date is the first day of a month
          if (startDay === 1) {
            // Calculate last day of previous month
            const prevMonth = startMonth === 1 ? 12 : startMonth - 1;
            const prevYear = startMonth === 1 ? startYear - 1 : startYear;
            const lastDayOfPrevMonth = new Date(prevYear, prevMonth, 0).getDate();
            
            // Format as YYYY-MM-DD
            const calculatedEndDate = `${prevYear}-${String(prevMonth).padStart(2, '0')}-${String(lastDayOfPrevMonth).padStart(2, '0')}`;
            
            console.log('📅 Calculated expiration date:', {
              startDate,
              endDate,
              status,
              calculatedEndDate
            });
            
            return calculatedEndDate;
          }
        } catch (error) {
          console.error('Error calculating expiration date:', error);
        }
      }
      
      // Return original end_date if no calculation needed
      return endDate;
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('MMMM DD, YYYY');
    },
    handlePayNow() {
     
      this.$emit('pay-now');
      
      console.log('Pay Now clicked - Payment gateway integration pending');
    },
  },
};
</script>

<style scoped>
.paywall-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.paywall-card {
  border-radius: 16px;
  overflow: hidden;
}

.paywall-title {
  flex-direction: column;
  padding: 40px 24px 24px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.paywall-title .headline {
  color: #424242;
  margin-top: 16px;
}

.pay-now-btn {
  height: 56px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.fill-height {
  min-height: calc(100vh - 40px);
}
</style>
